import Axios from 'axios';

const apiService = Axios.create({
  baseURL: process.env.VUE_APP_API + `api/v1/website/`
});

apiService.interceptors.request.use(function (config) {
  if (localStorage.getItem('token')) {
    config.headers = {
      'Authorization': 'Bearer ' + localStorage.getItem('token'),
      'X-UID': localStorage.getItem('uid') || 'Not-available'
    }
  }
  return config;
}, function (error) {
  // Do something with request error
  return
});

export default apiService;